(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["citizenship-application"] && !Shopify.designMode) return;
  try {
    
  function loadFloptropicaTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (window.floptropicaTurnstilePromise) return window.floptropicaTurnstilePromise;
    window.floptropicaTurnstilePromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.onload = () => resolve(window.turnstile);
      script.onerror = () => reject(new Error('The security check could not be loaded.'));
      document.head.appendChild(script);
    });
    return window.floptropicaTurnstilePromise;
  }

  function loadFloptropicaPayPal(url) {
    if (window.paypal) return Promise.resolve(window.paypal);
    if (window.floptropicaPayPalPromise) return window.floptropicaPayPalPromise;
    window.floptropicaPayPalPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = () => resolve(window.paypal);
      script.onerror = () => reject(new Error('PayPal could not be loaded. You can still pay securely by card or wallet.'));
      document.head.appendChild(script);
    });
    return window.floptropicaPayPalPromise;
  }

  function initialiseCitizenshipForms() {
    document.querySelectorAll('.citizenship-application[data-api-url]').forEach((root) => {
      if (root.dataset.initialised === 'true') return;
      root.dataset.initialised = 'true';
      const form = root.querySelector('[data-role="form"]');
      const submit = root.querySelector('[data-role="submit"]');
      const notice = root.querySelector('[data-role="notice"]');
      const approval = root.querySelector('[data-role="approval"]');
      if (!form || !submit || !notice) return;

      const paypalMethods = root.querySelector('[data-role="paypal-methods"]');
      const paypalButton = root.querySelector('[data-role="paypal-button"]');
      const payLaterButton = root.querySelector('[data-role="paypal-pay-later-button"]');

      const turnstileRoot = root.querySelector('[data-role="turnstile"]');
      let turnstileApi = null;
      let turnstileToken = '';
      if (turnstileRoot && root.dataset.turnstileSitekey) {
        loadFloptropicaTurnstile()
          .then((turnstile) => {
            if (!turnstile || turnstileRoot.dataset.rendered === 'true') return;
            turnstileApi = turnstile;
            root.dataset.turnstileWidgetId = turnstile.render(turnstileRoot, {
              sitekey: root.dataset.turnstileSitekey,
              action: 'citizenship_application',
              theme: 'auto',
              callback: (token) => {
                turnstileToken = token;
                root.dataset.turnstileReady = 'true';
              },
              'expired-callback': () => {
                turnstileToken = '';
                root.dataset.turnstileReady = 'false';
              },
              'error-callback': () => {
                turnstileToken = '';
                root.dataset.turnstileReady = 'false';
              },
            });
            turnstileRoot.dataset.rendered = 'true';
          })
          .catch((error) => {
            notice.textContent = error instanceof Error ? error.message : 'The security check could not be loaded.';
            notice.dataset.tone = 'error';
            notice.hidden = false;
          });
      }

      let paypalApplication = null;
      async function createPayPalOrder() {
        if (paypalApplication) return {orderId: paypalApplication.orderId};
        if (!form.reportValidity()) throw new Error('Complete the application before choosing PayPal.');
        if (!root.dataset.turnstileSitekey || !turnstileToken) {
          throw new Error('Complete the security check before continuing.');
        }
        const fields = new FormData(form);
        const response = await fetch(`${root.dataset.apiUrl}/v1/citizenship/paypal/orders`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({
            fullName: fields.get('fullName'),
            dateOfBirth: fields.get('dateOfBirth'),
            countryOfOrigin: fields.get('countryOfOrigin'),
            email: fields.get('email'),
            declaration: fields.get('declaration'),
            turnstileToken,
          }),
        });
        const result = await response.json();
        if (!response.ok || !result.orderId || !result.applicationId || !result.accessToken) {
          throw new Error(result.error || 'PayPal could not start the citizenship payment.');
        }
        paypalApplication = result;
        return {orderId: result.orderId};
      }

      async function capturePayPalPayment(data) {
        if (!paypalApplication?.orderId || !paypalApplication?.accessToken) {
          throw new Error('The PayPal payment reference is unavailable.');
        }
        const response = await fetch(
          `${root.dataset.apiUrl}/v1/citizenship/paypal/orders/${encodeURIComponent(data.orderId)}/capture`,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({token: paypalApplication.accessToken}),
          },
        );
        const result = await response.json();
        if (!response.ok || !result.applicationUrl) throw new Error(result.error || 'PayPal payment could not be confirmed.');
        window.location.assign(result.applicationUrl);
      }

      async function initialisePayPal() {
        if (!paypalMethods || !paypalButton || !root.dataset.apiUrl) return;
        try {
          const configResponse = await fetch(`${root.dataset.apiUrl}/v1/citizenship/paypal/config`, {headers: {Accept: 'application/json'}});
          const config = await configResponse.json();
          if (!configResponse.ok || !config.clientId || !config.sdkUrl) return;
          const paypal = await loadFloptropicaPayPal(config.sdkUrl);
          const instance = await paypal.createInstance({
            clientId: config.clientId,
            components: ['paypal-payments'],
            pageType: 'checkout',
          });
          const methods = await instance.findEligibleMethods({currencyCode: 'USD'});
          const paymentSessionOptions = {
            onApprove: capturePayPalPayment,
            onCancel: () => {
              notice.textContent = 'PayPal payment was cancelled. Your citizenship has not been approved; you may choose another payment method.';
              notice.dataset.tone = 'error';
              notice.hidden = false;
            },
            onError: (error) => {
              notice.textContent = error instanceof Error ? error.message : 'PayPal could not complete this payment. You can still pay securely by card or wallet.';
              notice.dataset.tone = 'error';
              notice.hidden = false;
              notice.focus();
            },
          };
          if (methods.isEligible('paypal')) {
            const session = instance.createPayPalOneTimePaymentSession(paymentSessionOptions);
            paypalButton.hidden = false;
            paypalMethods.hidden = false;
            paypalButton.addEventListener('click', async () => {
              try {
                await session.start({presentationMode: 'auto'}, createPayPalOrder());
              } catch (error) {
                paymentSessionOptions.onError(error);
              }
            });
          }
          if (methods.isEligible('paylater') && payLaterButton) {
            const details = methods.getDetails('paylater');
            const session = instance.createPayLaterOneTimePaymentSession(paymentSessionOptions);
            payLaterButton.productCode = details.productCode;
            payLaterButton.countryCode = details.countryCode;
            payLaterButton.hidden = false;
            paypalMethods.hidden = false;
            payLaterButton.addEventListener('click', async () => {
              try {
                await session.start({presentationMode: 'auto'}, createPayPalOrder());
              } catch (error) {
                paymentSessionOptions.onError(error);
              }
            });
          }
        } catch (error) {
          console.warn('PayPal eligibility was unavailable.', error);
        }
      }

      initialisePayPal();

      const params = new URLSearchParams(window.location.search);
      const access = new URLSearchParams(window.location.hash.replace(/^#/, ''));
      const applicationId = access.get('id');
      const applicationToken = access.get('token');

      async function showApplicationStatus() {
        if (!approval || !applicationId || !applicationToken) return;
        form.hidden = true;
        approval.hidden = false;
        const heading = approval.querySelector('[data-role="approval-heading"]');
        const message = approval.querySelector('[data-role="approval-message"]');
        const record = approval.querySelector('[data-role="approval-record"]');
        const actions = approval.querySelector('[data-role="approval-actions"]');
        const note = approval.querySelector('[data-role="approval-note"]');
        for (let attempt = 0; attempt < 30; attempt += 1) {
          try {
            const response = await fetch(
              `${root.dataset.apiUrl}/v1/citizenship/applications/${encodeURIComponent(applicationId)}/status?token=${encodeURIComponent(applicationToken)}`,
              {headers: {Accept: 'application/json'}},
            );
            const result = await response.json();
            if (!response.ok) throw new Error(result.error || 'The application record could not be opened.');
            if (result.approved) {
              heading.textContent = 'Your Floptropican citizenship has been approved';
              message.textContent = 'By formal determination of the Department of Immigration and Citizenship, you are entered in the national register as a citizen of the Island Nations of Floptropica.';
              approval.querySelector('[data-role="approval-flopid"]').textContent = result.flopID;
              approval.querySelector('[data-role="approval-evidence"]').textContent = result.evidenceNumber || 'Recorded on certificate';
              approval.querySelector('[data-role="certificate-link"]').href = result.certificateUrl;
              approval.querySelector('[data-role="account-link"]').href = result.accountUrl;
              record.hidden = false;
              actions.hidden = false;
              note.textContent = 'A formal approval email with the digital PDF attached has been dispatched. Your digital certificate is also available under Government in your Floptropica account.';
              return;
            }
            heading.textContent = 'Payment received — formal approval is processing';
            message.textContent = 'Stripe has returned you to Floptropica. The national register is completing your entry and preparing your official digital certificate.';
          } catch (error) {
            heading.textContent = 'Application status unavailable';
            message.textContent = error instanceof Error ? error.message : 'The application record could not be opened.';
            note.textContent = 'Your payment record is not affected. Please use the secure link in your approval email or Government in your account to access your digital certificate.';
            return;
          }
          await new Promise((resolve) => window.setTimeout(resolve, 2000));
        }
        note.textContent = 'Processing is taking longer than expected. Your approval email will arrive after the national register completes the record.';
      }

      if (params.get('application') === 'received') {
        if (applicationId && applicationToken) {
          showApplicationStatus();
        } else {
          notice.textContent = 'Application received. The registry will email your digital certificate after Stripe confirms approval.';
          notice.hidden = false;
        }
      } else if (params.get('application') === 'cancelled') {
        notice.textContent = 'Payment was cancelled. Your citizenship has not been approved; you may resume below.';
        notice.dataset.tone = 'error';
        notice.hidden = false;
      }

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        submit.disabled = true;
        submit.textContent = 'Opening secure processing…';
        notice.hidden = true;
        try {
          const fields = new FormData(form);
          if (!root.dataset.turnstileSitekey || !turnstileToken) {
            throw new Error('Complete the security check before continuing.');
          }
          const response = await fetch(`${root.dataset.apiUrl}/v1/citizenship/applications`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({
              fullName: fields.get('fullName'),
              dateOfBirth: fields.get('dateOfBirth'),
              countryOfOrigin: fields.get('countryOfOrigin'),
              email: fields.get('email'),
              declaration: fields.get('declaration'),
              turnstileToken,
            }),
          });
          const result = await response.json();
          if (!response.ok || !result.checkoutUrl) throw new Error(result.error || 'The citizenship registry is unavailable.');
          window.location.assign(result.checkoutUrl);
        } catch (error) {
          notice.textContent = error instanceof Error ? error.message : 'The citizenship registry is unavailable.';
          notice.dataset.tone = 'error';
          notice.hidden = false;
          notice.focus();
          submit.disabled = false;
          submit.textContent = 'Pay securely by card or wallet';
          if (turnstileApi && root.dataset.turnstileWidgetId) {
            turnstileToken = '';
            root.dataset.turnstileReady = 'false';
            turnstileApi.reset(root.dataset.turnstileWidgetId);
          }
        }
      });
    });
  }

  initialiseCitizenshipForms();
  document.addEventListener('shopify:section:load', initialiseCitizenshipForms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floptropica-transport-map"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-flop-transport]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const map = root.querySelector('.flop-transport__map');
    const clock = root.querySelector('[data-transport-clock]');
    const filters = root.querySelectorAll('[data-line-filter]');
    const departures = root.querySelectorAll('[data-departures] li');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const routes = new Map([...map.querySelectorAll('[data-route]')].map((path) => [path.dataset.route, path]));
    const lineMeta = { central: { color: '#00a9e8', every: 8, offset: 1, label: 'CEN' }, south: { color: '#e9328f', every: 12, offset: 4, label: 'SCW' }, cupcakkia: { color: '#13a65b', every: 10, offset: 3, label: 'CKR' }, potaxiene: { color: '#ffb238', every: 15, offset: 7, label: 'PTX' }, islandlink: { color: '#5b76d7', every: 18, offset: 9, label: 'ILC' } };
    const formatter = new Intl.DateTimeFormat('en-AU', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: 'Australia/Sydney' });
    const minuteFormatter = new Intl.DateTimeFormat('en-AU', { hour: 'numeric', minute: 'numeric', hour12: false, timeZone: 'Australia/Sydney' });
    const vehicles = [];
    const svgEl = (name) => document.createElementNS('http://www.w3.org/2000/svg', name);
    routes.forEach((path, line) => {
      const group = svgEl('g');
      group.classList.add('flop-transport__train');
      group.dataset.line = line;
      const circle = svgEl('circle'); circle.setAttribute('r', '11'); circle.setAttribute('fill', lineMeta[line].color);
      const label = svgEl('text'); label.textContent = lineMeta[line].label;
      group.append(circle, label); map.querySelector('[data-vehicle-layer]').append(group);
      vehicles.push({ line, path, group, length: path.getTotalLength(), offset: Object.keys(lineMeta).indexOf(line) * 0.19 });
    });
    const updateClock = () => { if (clock) clock.textContent = formatter.format(new Date()); };
    const minutesToday = () => { const parts = minuteFormatter.formatToParts(new Date()); return Number(parts.find((part) => part.type === 'hour')?.value || 0) * 60 + Number(parts.find((part) => part.type === 'minute')?.value || 0); };
    const updateDepartures = () => { const current = minutesToday(); departures.forEach((row) => { const meta = lineMeta[row.dataset.line]; const wait = (meta.offset - (current % meta.every) + meta.every) % meta.every; const value = row.querySelector('[data-departure]'); if (value) value.textContent = wait === 0 ? 'Boarding' : `${wait} min`; }); };
    const animate = (time) => { if (!reduceMotion) vehicles.forEach((vehicle) => { const position = ((time / 52000 + vehicle.offset) % 1) * vehicle.length; const point = vehicle.path.getPointAtLength(position); vehicle.group.setAttribute('transform', `translate(${point.x} ${point.y})`); }); if (!reduceMotion) requestAnimationFrame(animate); };
    const selectLine = (line) => { filters.forEach((button) => { const selected = button.dataset.lineFilter === line; button.classList.toggle('is-active', selected); button.setAttribute('aria-pressed', String(selected)); }); routes.forEach((path, id) => path.classList.toggle('is-muted', line !== 'all' && line !== id)); map.querySelectorAll('[data-station-lines]').forEach((station) => station.classList.toggle('is-muted', line !== 'all' && !station.dataset.stationLines.split(' ').includes(line))); vehicles.forEach((vehicle) => vehicle.group.classList.toggle('is-muted', line !== 'all' && vehicle.line !== line)); };
    filters.forEach((button) => button.addEventListener('click', () => selectLine(button.dataset.lineFilter || 'all')));
    updateClock(); updateDepartures(); window.setInterval(updateClock, 1000); window.setInterval(updateDepartures, 30000); if (!reduceMotion) requestAnimationFrame(animate); else vehicles.forEach((vehicle) => { const point = vehicle.path.getPointAtLength(vehicle.length * vehicle.offset); vehicle.group.setAttribute('transform', `translate(${point.x} ${point.y})`); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["government-header"]) return;
  try {
    
  if (!customElements.get('government-navigation')) {
    customElements.define('government-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = {signal: this.abortController.signal};
        const menu = this.querySelector('.government-header__menu');
        const network = this.querySelector('.government-header__network');
        const summary = menu.querySelector('summary');
        const desktop = matchMedia('(min-width: 1001px)');
        desktop.addEventListener('change', () => {
          menu.open = false; network.open = false;
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && (menu.open || network.open)) {
            if (network.open) { network.open = false; network.querySelector('summary').focus(); return; }
            menu.open = false;
            summary.focus();
          }
        }, options);
        this.addEventListener('click', (event) => {
          if (event.target.closest('a')) { menu.open = false; network.open = false; }
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) { menu.open = false; network.open = false; }
        }, options);
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
